import { ReactNode } from 'react';
import { isEmpty } from 'lodash';
import { showToast } from '../../components/Toast/showToast';
import { parametersQueries } from '../../queryClient/parameters/parameters.queries';
import useServices from '../../services/hooks/useServices';
import { Loader } from '../Routes.style';

export const LoadSystemParameters = ({ children }: { children: ReactNode }) => {
  const paramsQuery = parametersQueries.useSystemParameters();

  useServices();

  if (paramsQuery.isError || (paramsQuery.isSuccess && isEmpty(paramsQuery.systemParams))) {
    showToast('We encountered a problem. Please try to refresh the browser or come again later');

    return <Loader dataTestId="loader-load-load-system-params" />;
  }

  if (paramsQuery.isInitialLoading) {
    return <Loader dataTestId="loader-load-load-system-params" />;
  }

  return <>{children}</>;
};
